import { AuthEffects } from './auth.effects';
import { SharedEffects } from './shared.effects';
import { AccountEffects } from './account.effects';
import { AddressEffects } from './address.effects';
import { ImageEffects } from './image.effects';
import { OrganizationEffects } from './organization.effects';
import { TokensEffects } from './tokens.effects';
import { RideEffects } from './ride.effects';
import { OrderEffects } from './order.effects';
import { PassesEffects } from './passes.effects';
import { PremiumRideEffects } from './premium-ride.effects';

export const effects: any[] = [
    AuthEffects, 
    SharedEffects, 
    AccountEffects, 
    AddressEffects,
    ImageEffects,
    OrganizationEffects,
    TokensEffects,
    RideEffects,
    OrderEffects,
    PassesEffects,
    PremiumRideEffects
];
